import { string } from 'fp-ts';
import { orderBy } from 'lodash/fp';

interface OrderableEntity {
    ordering?: number;
    createdUtc?: string;
}

/** @deprecated use orderOrderableEntityArray instead */
export const orderOrderableEntities = orderBy(['ordering', 'createdUtc'], ['asc', 'asc']);

export const orderOrderableEntityArray = <T extends OrderableEntity>(entities: Array<T>) =>
    entities.toSorted(sortOrderableEntity);

export const sortOrderableEntity = <T extends OrderableEntity>(a: T, b: T) => {
    const orderingDiff = (a.ordering ?? 0) - (b.ordering ?? 0);

    if (orderingDiff || !a.createdUtc || !b.createdUtc) {
        return orderingDiff;
    }

    return string.Ord.compare(a.createdUtc, b.createdUtc);
};
